const { Core, Events } = Global;

customElements.define('main-nav-mobile', class extends Core {
    elements = {
        $: [['level'], 'toolbar']
    }

    render() {
        this.isV2 = this.classList.contains('@v2');
        this.sub(Events.HEADER_UPDATE, this._handleHeaderUpdate, { global: true, once: true });
        this.sub(Events.HEADER_TOOLBAR_UPDATE, this._handleToolbarUpdate, { global: true, once: true });
        this.$({
            change: this._handleChange
        })
    }
    
    _handleChange(e) {
        if (this.isV2) {
            const input = e.target;
            if (input.tagName === 'INPUT' && input.type === 'checkbox' && input.id) {
                const label = this.querySelector(`label[for="${input.id}"]`);
                if (label) {
                    if (input.checked) {
                        label.classList.add('@open');
                    } else {
                        label.classList.remove('@open');
                    }
                }
            }
            return;
        }
        this.style.setProperty(`--${this.tagName.toLowerCase()}-level`, e.target.value);
    }

    _handleHeaderUpdate(items) {
        if (this.isV2) {
            items.forEach(({ level, children }) => {
                // Append level 0 (header/toolbars) normally
                if (level === 0) {
                    const target = this.$('level').find(l => +l.dataset.level === 0);
                    target && target.append(...children);
                    return;
                }
                // For levels 1..3: place input + content adjacent to their label
                const nodes = Array.from(children).filter(n => n.nodeType === 1);
                for (let i = 0; i < nodes.length; i++) {
                    const node = nodes[i];
                    if (node.tagName === 'INPUT' && node.id) {
                        const group = [node];
                        const next = nodes[i + 1];
                        const isLevelContent = next && next.tagName === 'DIV' && (next.className.includes('level-content'));
                        if (isLevelContent) {
                            group.push(next);
                            i++;
                        }
                        const label = this.querySelector(`label[for="${node.id}"]`);
                        if (label) {
                            const existing = label.nextElementSibling;
                            if (existing && existing.tagName === 'INPUT' && existing.id === node.id) continue;
                            label.after(...group);
                        }
                    }
                }
            });
            return;
        }
        // Default behavior (v1): append captured children into corresponding level containers
        this.$('level').map(level => {
            const match = items.find(item => +level.dataset.level === item.level);
            if (match) {
                level.append(...match.children);
            }
        });
    }

    _handleToolbarUpdate(items) {
        this.$('toolbar').append(...items);
    }
});
